import http from "../../http-common";

const createArtist = async (artistData) => {
  return await http
    .post("/admin/registrations/create-artist", artistData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateArtist = async (artistId, artistData) => {
  return await http
    .put(`/admin/registrations/update-artist/${artistId}`, artistData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const uploadArtistImage = async (artistId, imageType, formData) => {
  return await http
    .post(
      `/admin/registrations/upload-artist-image/${artistId}/${imageType}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getAllArtists = async () => {
  return await http
    .get("/admin/registrations/artists")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const generateArtist = async ({ name }) => {
  return await http
    .post("/admin/registrations/generate-artist", { name })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const adaptArtistImage = async ({
  image,
  mimeType,
  format,
  artistName,
  sourceUrl,
}) => {
  return await http
    .post(
      "/admin/registrations/adapt-artist-image",
      {
        image,
        mimeType,
        format,
        artistName,
        sourceUrl,
      },
      { timeout: 120000 }
    )
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  createArtist,
  updateArtist,
  uploadArtistImage,
  getAllArtists,
  generateArtist,
  adaptArtistImage,
};
